import Axios from "axios";
import { SENDMAIL } from "../constants/urls";
import { ES_DESARROLLO } from "../constants/entorno";

/**
 * En desarrollo ningún correo sale a sus destinatarios: sin
 * REACT_APP_EMAIL_DESTINO_DEV no se envía nada, y con ella todo va sólo a esa
 * casilla, con los destinatarios originales en el asunto.
 */
function destinoSegunEntorno(to, subject) {
  if (!ES_DESARROLLO) return { to, subject };
  const originales = Array.isArray(to) ? to.join(", ") : String(to);
  const destino = (process.env.REACT_APP_EMAIL_DESTINO_DEV || "").trim();
  if (!destino) {
    console.warn(`[development] Envío de correo: no se ejecuta. Para: ${originales}. Asunto: ${subject}`);
    return null;
  }
  return { to: destino, subject: `[DEV para ${originales}] ${subject}` };
}

  /**
   * Método encargado de enviar un Email en formato Texto.
   * @param {*} to Destinatario.
   * @param {*} subject Asunto.
   * @param {*} text Contenido texto.
   * @returns 
   */
   export async function SendText(to, subject, text) {
    try {
      const destino = destinoSegunEntorno(to, subject);
      if (!destino) return { omitido: true };
      ({ to, subject } = destino);
      let url = `${SENDMAIL}/email`;
      let response = await Axios.post(url, { to, subject, text });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Método encargado de enviar un Email en formato HTML.
   * @param {*} to Destinatario.
   * @param {*} subject Asunto.
   * @param {*} html Contenido HTML.
   * @returns 
   */
  export async function SendHTML (to, subject, html) {
    try {
      const destino = destinoSegunEntorno(to, subject);
      if (!destino) return { omitido: true };
      ({ to, subject } = destino);
      let url = `${SENDMAIL}/email`;
      let response = await Axios.post(url, { to, subject, html });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
